import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { map, switchMap } from 'rxjs';

import { DynamicFormsService } from '@services/dynamic-forms.service';

@Component({
  selector: 'cvx-dynamic-form-details-page',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './dynamic-form-details-page.component.html',
  styleUrl: './dynamic-form-details-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicFormDetailsPageComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly service = inject(DynamicFormsService);

  protected readonly form = toSignal(
    this.route.paramMap.pipe(
      map((params) => params.get('id') ?? ''),
      switchMap((id) => this.service.getById(id))
    ),
    { initialValue: null }
  );
}
